angular.module('app').component('wwSorting', {
    templateUrl: 'js/components/ww-sorting/index.html',
    controller: WWSortingController,
    controllerAs: '$sort',
    bindings: {
        items: '=',
        field: '=',
        customStyle: '<',
        afterSorting: '='
    },
});

WWSortingController.$inject = [];

function WWSortingController() {
    var $ctrl = this;
    $ctrl.order = {
        asc: {
            key: false,
            svg: 'sort-up.svg',
            items: []
        },
        desc: {
            key: true,
            svg: 'sort-down.svg',
            items: []
        },
        none: {
            key: null,
            svg: 'sort.svg',
            items: []
        },
    };

    $ctrl.$onInit = function () {
        $ctrl.currentOrder = $ctrl.order.none;
        $ctrl.order.none.items = angular.copy($ctrl.items);
        $ctrl.order.asc.items = angular.copy($ctrl.items.sort(dynamicSort($ctrl.field, $ctrl.order.asc.key)));
        $ctrl.order.desc.items = angular.copy($ctrl.items.sort(dynamicSort($ctrl.field, $ctrl.order.desc.key)));
    };

    $ctrl.changeSortOrder = function () {
        switch ($ctrl.currentOrder.key) {
            case $ctrl.order.none.key:
                $ctrl.currentOrder = $ctrl.order.asc;
                break;
            case $ctrl.order.asc.key:
                $ctrl.currentOrder = $ctrl.order.desc;
                break;
            case $ctrl.order.desc.key:
                $ctrl.currentOrder = $ctrl.order.none;
                break;
            default:
                break;
        }

        $ctrl.items = $ctrl.currentOrder.items;

        if (typeof $ctrl.afterSorting === 'function') {
            $ctrl.afterSorting($ctrl.items);
        }
    }

    function dynamicSort(field, reverse) {
        return function (a, b) {
            var first = a[field];
            var second = b[field];

            var result;

            if(typeof first === 'string' && typeof second === 'string') {
                result = first.localeCompare(second, undefined, { sensitivity: 'accent' });
            } else if (first >= second) {
                result = first > second ? 1 : 0;
            } else {
                result = -1;
            }
            return result * (reverse ? -1 : 1);
        };
    }
}
